<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!RecordId">Adding {{PageTitle}}</span>
                <span *ngIf="RecordId">Update {{PageTitle}}</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="IpdResourcesForm" (submit)="createIpdResource()">
                
                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-4 col-lg-4 right-border">
                                <div class="form-group">
                                    <label class="form-label">Name *</label>
                                    <input type="text" formControlName="name" class="form-control" />
                                    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                        <div *ngIf="f.name.errors.required">Name is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4 right-border">
                                <div class="form-group">
                                    <label class="form-label">Price *</label>
                                    <input type="number" formControlName="price" class="form-control" />
                                    <div *ngIf="submitted && f.price.errors" class="invalid-feedback">
                                        <div *ngIf="f.price.errors.required">Price is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <label class="form-label">Status *</label>
                                <mat-select  placeholder="Status" formControlName="status">
                                    <mat-option [value]="1">Active</mat-option>
                                    <mat-option [value]="0">In-Active</mat-option>
                                   
                                </mat-select>
                                <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                    <div *ngIf="f.status.errors.required">Status is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> 
                         <span *ngIf="!RecordId">Create {{PageTitle}}</span>
                        <span *ngIf="RecordId">Update {{PageTitle}}</span>    
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>